import axios from "axios";
import { FETCH_ALL_ALERTWARNING_API } from "../Constants/Apis";

export const getAlertWarnings = async () => {
  try {
    return axios.get(FETCH_ALL_ALERTWARNING_API);
  } catch (e) {
    console.log(e);
  }
};

export const createAlertWarning = async (payload) => {
  try {
    return axios.post(FETCH_ALL_ALERTWARNING_API, payload);
  } catch (e) {
    console.log(e);
  }
};

export const updateAlertWarning = async (id, payload) => {
  try {
    return axios.put(`${FETCH_ALL_ALERTWARNING_API}/${id}`, payload);
  } catch (e) {
    console.log(e);
  }
};

export const deleteAlertWarning = async (id) => {
  try {
    return axios.delete(`${FETCH_ALL_ALERTWARNING_API}/${id}`);
  } catch (e) {
    console.log(e);
  }
};

export const bulkUpsertAlertWarnings = async ({ items, counterCode = "ECOMMRI" }) => {
  try {
    return axios.post(`${FETCH_ALL_ALERTWARNING_API}/bulk-upsert`, { items, counterCode });
  } catch (e) {
    console.log(e);
  }
};

export const bulkDeleteAlertWarnings = async ({ skus, counterCode = "ECOMMRI" }) => {
  try {
    return axios.post(`${FETCH_ALL_ALERTWARNING_API}/bulk-delete`, { skus, counterCode });
  } catch (e) {
    console.log(e);
  }
};